import state from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const adminSetting = {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};

export default adminSetting;
